import React from 'react';
import RenderContent from 'app/components/layout/RenderContent';
import { Route } from 'react-router-dom';
import PayoutSummaryReport from './components/PayoutSummaryReport';
import PayoutDetailedReport from './components/PayoutDetailedReport';
import RefundDetailedReport from './components/RefundDetailedReport';
import BankDebitDetailedReport from './components/BankDebitDetailedReport';
import MatchPaymentsGridReport from './components/MatchPaymentsGridReport';
import ReportsList from './components/ReportsList';


interface IReportsLayoutProps {
  appReady: boolean;
  match: any;
}
export default class ReportsLayout extends React.Component<IReportsLayoutProps> {
  static defaultProps: IReportsLayoutProps = {
    appReady: false,
    match: undefined,
  };

  render(): React.ReactNode {
    return (
      <RenderContent checkOrgLoaded className="reports-app" match={this.props.match}>
        <Route
          exact
          path={['/reports']}
          render={(): React.ReactNode => <ReportsList {...this.props} />}
        />
        <Route
          exact
          path="/reports/payout-summary"
          render={(): React.ReactNode => <PayoutSummaryReport {...this.props} />}
        />
        <Route
          exact
          path="/reports/payout-detailed"
          render={(): React.ReactNode => <PayoutDetailedReport {...this.props} />}
        />
        <Route
          exact
          path="/reports/refund-detailed"
          render={(): React.ReactNode => <RefundDetailedReport {...this.props} />}
        />
        <Route
          exact
          path="/reports/bank-debit-detailed"
          render={(): React.ReactNode => <BankDebitDetailedReport {...this.props} />}
        />
        <Route
          exact
          path="/reports/match-payments-grid"
          render={(): React.ReactNode => <MatchPaymentsGridReport {...this.props} />}
        />
      </RenderContent>
    );
  }
}
